import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { EstatePlanPartyType } from '@/modules/estate/enums/EstatePlanPartyType';
import { PartnershipInvitationType } from '@/modules/partnershipinvitation/constants/PartnershipInvitationType';

export class LightDiagnosticForm extends BaseModel {
  situations: string[] | [];
  goals: string[] | [];
  jurisdictionId?: number;
  showBillingPlan: boolean;
  coupleType: string;
  partnershipInvitationType: PartnershipInvitationType;

  constructor(model: Partial<LightDiagnosticForm> = {}) {
    super();

    this.situations = model.situations ?? [];
    this.goals = model.goals ?? [];
    this.jurisdictionId = model.jurisdictionId ?? undefined;
    this.showBillingPlan = model.showBillingPlan ?? true;
    this.coupleType = model.coupleType ?? EstatePlanPartyType.INDIVIDUAL.key;
    this.partnershipInvitationType =
      model.partnershipInvitationType ?? PartnershipInvitationType.CLIENT;
  }

  isGoalSelected(goalKey: string): boolean {
    return this.goals.includes(goalKey);
  }

  isSituationSelected(situationKey: string): boolean {
    return this.situations.includes(situationKey);
  }

  addSituationKey(situationKey: string): void {
    const index: number = this.situations.indexOf(situationKey);
    if (index > -1) {
      this.situations.splice(index, 1);
    } else {
      this.situations.push(situationKey);
    }
  }

  addGoalKey(goalKey: string): void {
    const index: number = this.goals.indexOf(goalKey);
    if (index > -1) {
      this.goals.splice(index, 1);
    } else {
      this.goals.push(goalKey);
    }
  }
}
